export interface RpcRequest {
  id: string
  namespace: string
  endpoint: string
  arguments: any[]
}

export interface RpcResponse {
  id: string
  result?: any
  error?: Error
}

export class RpcRequestTimeout extends Error {
  public name = 'RpcRequestTimeout'
}

export class RpcInvalidEndpoint extends Error {
  public name = 'RpcInvalidEndpoint'
}
